import { render, staticRenderFns } from "./AttackChipDialog.vue?vue&type=template&id=925006f4&scoped=true"
import script from "./AttackChipDialog.vue?vue&type=script&lang=js"
export * from "./AttackChipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925006f4",
  null
  
)

export default component.exports